import { useState, useEffect, useRef } from 'react';
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import "firebase/compat/database";
import CloseIcon from '@mui/icons-material/Close'; // or your preferred close icon
import axios from "axios";
import jsPDF from 'jspdf'; // Import jsPDF
import html2canvas from 'html2canvas';

const SchoolAdmissionForm = () => {
  const today = new Date().toISOString().split('T')[0];

  // Extract UDISE number from URL
  const getUdiseFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('udise') || '';
  };

  const [udiseNumber, setUdiseNumber] = useState(getUdiseFromUrl());
  const [schoolData, setSchoolData] = useState("");
  const [schoolLanguage, setSchoolLanguage] = useState('');

  const [showPrintButton, setShowPrintButton] = useState(false);

  // Add these state variables
  const [religion, setReligion] = useState("");
  const [caste, setCaste] = useState("");
  const [showNewReligionForm, setShowNewReligionForm] = useState(false);
  const [showNewCasteForm, setShowNewCasteForm] = useState(false);
  const [newReligion, setNewReligion] = useState("");
  const [newCaste, setNewCaste] = useState("");
  const [isEditingReligion, setIsEditingReligion] = useState(false);
  const [isEditingCaste, setIsEditingCaste] = useState(false);
  const [religions, setReligions] = useState([]);
  const [castes, setCastes] = useState([]);
  const [showNewMotherToungeForm, setShowNewMotherToungeForm] = useState(false);
  const [motherTounge, setMotherTounge] = useState("");
  const [motherTounges, setMotherTounges] = useState([]);
  const [isEditingMotherTounge, setIsEditingMotherTounge] = useState(false);
  const [editMotherToungeIndex, setEditMotherToungeIndex] = useState(null);
  const [newMotherTounge, setNewMotherTounge] = useState("");
  const [classes, setClasses] = useState([]);

  const [isSubmitted, setIsSubmitted] = useState(false);


  const fetchClasses = async () => {
    try {
      if (!udiseNumber) return;
      const response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/classDiv.json`
      );
      const data = response.data || {};
      const classesArray = Object.keys(data).map(key => ({ name: key }));
      setClasses(classesArray);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  useEffect(() => {
    fetchClasses(); // Fetch classes on component mount
  }, [udiseNumber]);


  // Add these handler functions
  const handleReligionChange = (e) => {
    const value = e.target.value;
    if (value === "addNewRel") {
      setShowNewReligionForm(true);
      setReligion("");
    } else {
      setReligion(value);
      setFormData({ ...formData, religion: value });
    }
  };

  const handleCasteChange = (e) => {
    const value = e.target.value;
    if (value === "addNewCaste") {
      setShowNewCasteForm(true);
      setCaste("");
    } else {
      setCaste(value);
      setFormData({ ...formData, caste: value });
    }
  };

  const handleNewReligionSubmit = () => {
    if (newReligion.trim() === "") return;

    if (isEditingReligion) {
      // Update existing religion
      const updatedReligions = [...religions];
      updatedReligions[religions.indexOf(religion)] = newReligion;
      setReligions(updatedReligions);
      setReligion(newReligion);
      setFormData({ ...formData, religion: newReligion });
    } else {
      // Add new religion
      setReligions([...religions, newReligion]);
      setReligion(newReligion);
      setFormData({ ...formData, religion: newReligion });
    }

    setNewReligion("");
    setShowNewReligionForm(false);
    setIsEditingReligion(false);
  };

  const handleNewCasteSubmit = () => {
    if (newCaste.trim() === "") return;

    if (isEditingCaste) {
      // Update existing caste
      const updatedCastes = [...castes];
      updatedCastes[castes.indexOf(caste)] = newCaste;
      setCastes(updatedCastes);
      setCaste(newCaste);
      setFormData({ ...formData, caste: newCaste });
    } else {
      // Add new caste
      setCastes([...castes, newCaste]);
      setCaste(newCaste);
      setFormData({ ...formData, caste: newCaste });
    }

    setNewCaste("");
    setShowNewCasteForm(false);
    setIsEditingCaste(false);
  };

  const handleRowClickReligion = (index) => {
    setReligion(religions[index]);
    setNewReligion(religions[index]);
    setIsEditingReligion(true);
  };

  const handleRowClickCaste = (index) => {
    setCaste(castes[index]);
    setNewCaste(castes[index]);
    setIsEditingCaste(true);
  };

  const closeButtonClick = () => {
    setShowNewReligionForm(false);
    setShowNewCasteForm(false);
    setNewReligion("");
    setNewCaste("");
    setShowNewMotherToungeForm(false);
    setIsEditingReligion(false);
    setIsEditingCaste(false);
  };


  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const handleFocus = (index) => {
    if (inputs.current[index]) {
      inputs.current[index].focus();
    }
  };
  const handleMotherToungeChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewMotherTounge") {
      setShowNewMotherToungeForm(true);
    } else {
      setMotherTounge(selectedValue);
      setShowNewMotherToungeForm(false);
    }
  };
  const handleNewMotherToungeSubmit = () => {
    if (newMotherTounge.trim() !== "") {
      if (isEditingMotherTounge) {
        const updatedMotherTounges = motherTounges.map((motherTounge, index) =>
          index === editMotherToungeIndex ? newMotherTounge : motherTounge
        );
        setMotherTounges(updatedMotherTounges);
        setIsEditingMotherTounge(false);
        setEditMotherToungeIndex(null);
      } else {
        setMotherTounges([...motherTounges, newMotherTounge]);
      }
      setNewMotherTounge('');
      setShowNewMotherToungeForm(false);
    }
  };
  const handleRowClickMotherTounge = (index) => {
    setIsEditingMotherTounge(true);
    setEditMotherToungeIndex(index);
    setNewMotherTounge(motherTounges[index]);
    setShowNewMotherToungeForm(true);
  };

  const inputs = useRef([]);

  useEffect(() => {
    if (!udiseNumber) return;
    const schoolDataRef = firebase.database().ref(`schoolRegister/${udiseNumber}/schoolData`);
    schoolDataRef.once('value')
      .then((snapshot) => {
        const data = snapshot.val();
        if (data) {
          setSchoolLanguage(data.language || '');

          setSchoolData(data)
        }
      })
      .catch((error) => {
        console.error("Error fetching schoolData:", error);
      });
  }, [udiseNumber]);

  const [formData, setFormData] = useState({
    aparId: "",
    panId: "",
    educationalYear: "",
    stdSurname: "",
    stdName: "",
    stdFather: "",
    stdMother: "",
    stdAdharNo: "",
    religion: "",
    caste: "",
    subCaste: "",
    category: "",
    nationality: "",
    motherTounge: "",
    dateOfAdmission: today,
    country: "",
    state: "",
    district: "",
    taluka: "",
    birthPlace: "",
    gender: "",
    dob: "",
    mobileNo: "",
    prevSchool: "",
    currentClass: "",
    stdPhoto: "",
    isMinority: false,
    bloodGroup: "",
    fOccupation: "",
    mOccupation: "",
    fMobile: "",
    mMobile: "",
    birthmark: "",
    address: "",
    pincode: "",
    adharmobileNo: "",
    accHolderName: "",
    accNo: "",
    bankName: "",
    branchName: "",
    IFSC: "",
    stdemailId: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const [submitError, setSubmitError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = value;

    // Format Aadhar numbers
    if (name === "stdAdharNo" || name === "pAdhar") {
      const numericValue = value.replace(/\D/g, "");
      newValue = numericValue
        .slice(0, 12)
        .replace(/(.{4})/g, "$1 ")
        .trim();
    }

    // Format mobile numbers
    if (["mobileNo", "fMobile", "mMobile", "adharmobileNo"].includes(name)) {
      const numericValue = value.replace(/\D/g, "");
      newValue = numericValue.slice(0, 10);
    }

    // Format pincode
    if (name === "pincode") {
      const numericValue = value.replace(/\D/g, "");
      newValue = numericValue.slice(0, 6);
    }

    // Update form state
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : newValue
    });
  };


  const uploadImage = async (e) => {
    const file = e.target.files[0];

    if (file) {
      const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB

      if (file.size > maxSizeInBytes) {
        alert("Image size should not exceed 2 MB.");
        return;
      }

      const storageRef = firebase.storage().ref();
      const imageRef = storageRef.child(`${udiseNumber}/${formData.stdAdharNo}${file.name}`);

      try {
        await imageRef.put(file);
        const downloadURL = await imageRef.getDownloadURL();
        setFormData({
          ...formData,
          stdPhoto: downloadURL // Store URL instead of base64
        });
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!udiseNumber) {
      setSubmitError("UDISE number is required. Add it to the URL as ?udise=YOUR_UDISE_NUMBER");
      return;
    }
    setIsSubmitting(true);
    setSubmitError("");
    setSubmitMessage("");
    setShowPrintButton(false);


    try {
      const dbRef = firebase.database().ref(`schoolRegister/${udiseNumber}/AdmissionFrom`);
      const snapshot = await dbRef.once("value");
      const existingData = snapshot.val();

      // Remove empty fields
      const cleanedFormData = Object.fromEntries(
        Object.entries(formData).filter(([_, value]) => value !== "" && value !== null && value !== undefined)
      );

      // Get next srNo
      let nextSrNo = 1;
      if (existingData) {
        const keys = Object.keys(existingData)
          .map(key => parseInt(key))
          .filter(num => !isNaN(num));
        const maxSrNo = Math.max(...keys, 0);
        nextSrNo = maxSrNo + 1;
      }

      // Check for duplicate
      const isDuplicate = existingData && Object.values(existingData).some(
        data => JSON.stringify(data) === JSON.stringify(cleanedFormData)
      );

      if (isDuplicate) {
        setSubmitMessage("Data has already been saved successfully.");
        setShowPrintButton(true);
      } else {
        await dbRef.child(nextSrNo).set(cleanedFormData);
        // resetForm();
        alert("Form submitted successfully!");
        setSubmitMessage("Form submitted successfully!");
        setIsSubmitted(true);
        setShowPrintButton(true);
      }

    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitError("An error occurred while submitting the form: ");
    } finally {
      setIsSubmitting(false);
    }
  };

  function convertDateToWords(date) {
    const dateObj = new Date(date);
    const dayValue = [
      { 1: "First" }, { 2: "Second" }, { 3: "Third" }, { 4: "Fourth" }, { 5: "Fifth" }, { 6: "Sixth" },
      { 7: "Seventh" }, { 8: "Eighth" }, { 9: "Ninth" }, { 10: "Tenth" }, { 11: "Eleventh" }, { 12: "Twelfth" },
      { 13: "Thirteenth" }, { 14: "Fourteenth" }, { 15: "Fifteenth" }, { 16: "Sixteenth" }, { 17: "Seventeenth" },
      { 18: "Eighteenth" }, { 19: "Nineteenth" }, { 20: "Twentieth" }, { 21: "Twenty-First" }, { 22: "Twenty-Second" },
      { 23: "Twenty-Third" }, { 24: "Twenty-Fourth" }, { 25: "Twenty-Fifth" }, { 26: "Twenty-Sixth" },
      { 27: "Twenty-Seventh" }, { 28: "Twenty-Eighth" }, { 29: "Twenty-Ninth" }, { 30: "Thirtieth" },
      { 31: "Thirty-First" }
    ];
    const dayValueInMarathi = [
      { 1: "एक" }, { 2: "दोन" }, { 3: "तीन" }, { 4: "चार" }, { 5: "पाच" }, { 6: "सहा" },
      { 7: "सात" }, { 8: "आठ" }, { 9: "नऊ" }, { 10: "दहा" }, { 11: "अकरा" }, { 12: "बारा" },
      { 13: "तेरा" }, { 14: "चौदा" }, { 15: "पंधरा" }, { 16: "सोळा" }, { 17: "सतरा" },
      { 18: "अठरा" }, { 19: "एकोणीस" }, { 20: "वीस" }, { 21: "एकवीस" }, { 22: "बावीस" },
      { 23: "तेवीस" }, { 24: "चोवीस" }, { 25: "पंचवीस" }, { 26: "सव्वीस" },
      { 27: "सत्तावीस" }, { 28: "अठ्ठावीस" }, { 29: "एकोणतीस" }, { 30: "तीस" },
      { 31: "एकतीस" }
    ];
    const monthNames = {
      1: "January", 2: "February", 3: "March", 4: "April", 5: "May", 6: "June",
      7: "July", 8: "August", 9: "September", 10: "October", 11: "November", 12: "December"
    };
    const monthNamesInMarathi = {
      1: "जानेवारी", 2: "फेब्रुवारी", 3: "मार्च", 4: "एप्रिल", 5: "मे", 6: "जून",
      7: "जुलै", 8: "ऑगस्ट", 9: "सप्टेंबर", 10: "ऑक्टोबर", 11: "नोव्हेंबर", 12: "डिसेंबर"
    };

    const yearValue = {
      1970: "nineteen seventy", 1971: "nineteen seventy one", 1972: "nineteen seventy two", 1973: "nineteen seventy three", 1974: "nineteen seventy four", 1975: "nineteen seventy five", 1976: "nineteen seventy six", 1977: "nineteen seventy seven", 1978: "nineteen seventy eight", 1979: "nineteen seventy nine", 1980: "nineteen eighty", 1981: "nineteen eighty one", 1982: "nineteen eighty two", 1983: "nineteen eighty three", 1984: "nineteen eighty four", 1985: "nineteen eighty five", 1986: "nineteen eighty six", 1987: "nineteen eighty seven", 1988: "nineteen eighty eight", 1989: "nineteen eighty nine", 1990: "nineteen ninety",
      1990: "nineteen ninety", 1991: "nineteen ninety one", 1992: "nineteen ninety two", 1993: "nineteen ninety three",
      1994: "nineteen ninety four", 1995: "nineteen ninety five", 1996: "nineteen ninety six", 1997: "nineteen ninety seven",
      1998: "nineteen ninety eight", 1999: "nineteen ninety nine", 2000: "two thousand", 2001: "two thousand one",
      2002: "two thousand two", 2003: "two thousand three", 2004: "two thousand four", 2005: "two thousand five",
      2006: "two thousand six", 2007: "two thousand seven", 2008: "two thousand eight", 2009: "two thousand nine",
      2010: "two thousand ten", 2011: "two thousand eleven", 2012: "two thousand twelve", 2013: "two thousand thirteen",
      2014: "two thousand fourteen", 2015: "two thousand fifteen", 2016: "two thousand sixteen", 2017: "two thousand seventeen",
      2018: "two thousand eighteen", 2019: "two thousand nineteen", 2020: "two thousand twenty", 2021: "two thousand twenty one",
      2022: "two thousand twenty two", 2023: "two thousand twenty three", 2024: "two thousand twenty four", 2025: "two thousand twenty five",
      2026: "two thousand twenty six", 2027: "two thousand twenty seven", 2028: "two thousand twenty eight", 2029: "two thousand twenty nine",
      2030: "two thousand thirty", 2031: "two thousand thirty one", 2032: "two thousand thirty two", 2033: "two thousand thirty three",
      2034: "two thousand thirty four", 2035: "two thousand thirty five", 2036: "two thousand thirty six", 2037: "two thousand thirty seven",
      2038: "two thousand thirty eight", 2039: "two thousand thirty nine", 2040: "two thousand forty", 2041: "two thousand forty one",
      2042: "two thousand forty two", 2043: "two thousand forty three", 2044: "two thousand forty four", 2045: "two thousand forty five",
      2046: "two thousand forty six", 2047: "two thousand forty seven", 2048: "two thousand forty eight", 2049: "two thousand forty nine",
      2050: "two thousand fifty", 2051: "two thousand fifty one", 2052: "two thousand fifty two", 2053: "two thousand fifty three",
      2054: "two thousand fifty four", 2055: "two thousand fifty five", 2056: "two thousand fifty six", 2057: "two thousand fifty seven",
      2058: "two thousand fifty eight", 2059: "two thousand fifty nine", 2060: "two thousand sixty", 2061: "two thousand sixty one",
      2062: "two thousand sixty two", 2063: "two thousand sixty three", 2064: "two thousand sixty four", 2065: "two thousand sixty five",
      2066: "two thousand sixty six", 2067: "two thousand sixty seven", 2068: "two thousand sixty eight", 2069: "two thousand sixty nine",
      2070: "two thousand seventy", 2071: "two thousand seventy one", 2072: "two thousand seventy two", 2073: "two thousand seventy three",
      2074: "two thousand seventy four", 2075: "two thousand seventy five", 2076: "two thousand seventy six", 2077: "two thousand seventy seven",
      2078: "two thousand seventy eight", 2079: "two thousand seventy nine", 2080: "two thousand eighty", 2081: "two thousand eighty one",
      2082: "two thousand eighty two", 2083: "two thousand eighty three", 2084: "two thousand eighty four", 2085: "two thousand eighty five",
      2086: "two thousand eighty six", 2087: "two thousand eighty seven", 2088: "two thousand eighty eight", 2089: "two thousand eighty nine",
      2090: "two thousand ninety", 2091: "two thousand ninety one", 2092: "two thousand ninety two", 2093: "two thousand ninety three",
      2094: "two thousand ninety four", 2095: "two thousand ninety five", 2096: "two thousand ninety six", 2097: "two thousand ninety seven",
      2098: "two thousand ninety eight", 2099: "two thousand ninety nine", 2100: "two thousand one hundred"
    };

    const yearValueInMarathi = {
      1970: "एकोणीशे सत्तर", 1971: "एकोणीशे एक्काहत्तर", 1972: "एकोणीशे बाहत्तर", 1973: "एकोणीशे त्र्याहत्तर", 1974: "एकोणीशे चौर्याहत्तर", 1975: "एकोणीशे पंच्याहत्तर", 1976: "एकोणीशे शहात्तर", 1977: "एकोणीशे सत्याहत्तर", 1978: "एकोणीशे अठ्ठ्याहत्तर", 1979: "एकोणीशे एकोणऐंशी", 1980: "एकोणीशे ऐंशी", 1981: "एकोणीशे एक्क्याऐंशी", 1982: "एकोणीशे ब्याऐंशी",
      1983: "एकोणीशे त्र्याऐंशी", 1984: "एकोणीशे चौर्याऐंशी", 1985: "एकोणीशे पंच्याऐंशी", 1986: "एकोणीशे शहाऐंशी", 1987: "एकोणीशे सत्त्याऐंशी", 1988: "एकोणीशे अठ्ठ्याऐंशी", 1989: "एकोणीशे एकोणनव्वद", 1990: "एकोणीशे नव्वद", 1991: "एकोणीशे एक्यान्नव", 1992: "एकोणीशे ब्यान्नव", 1993: "एकोणीशे त्र्यान्नव", 1994: "एकोणीशे चौर्यान्नव", 1995: "एकोणीशे पंच्यान्नव", 1996: "एकोणीशे शहान्नव", 1997: "एकोणीशे सत्त्यान्नव", 1998: "एकोणीशे अठ्यान्नव", 1999: "एकोणीशे नव्यान्नव", 2000: "दोन हजार",
      2001: "दोन हजार एक", 2002: "दोन हजार दोन", 2003: "दोन हजार तीन", 2004: "दोन हजार चार", 2005: "दोन हजार पाच", 2006: "दोन हजार सहा", 2007: "दोन हजार सात", 2008: "दोन हजार आठ", 2009: "दोन हजार नऊ", 2010: "दोन हजार दहा",
      2011: "दोन हजार अकरा", 2012: "दोन हजार बारा", 2013: "दोन हजार तेरा", 2014: "दोन हजार चौदा", 2015: "दोन हजार पंधरा", 2016: "दोन हजार सोळा", 2017: "दोन हजार सतरा", 2018: "दोन हजार अठरा", 2019: "दोन हजार एकोणीस",
      2020: "दोन हजार वीस", 2021: "दोन हजार एकवीस", 2022: "दोन हजार बावीस", 2023: "दोन हजार तेवीस", 2024: "दोन हजार चोवीस", 2025: "दोन हजार पंचवीस", 2026: "दोन हजार सव्वीस", 2027: "दोन हजार सत्तावीस", 2028: "दोन हजार अठ्ठावीस",
      2029: "दोन हजार एकोणतीस", 2030: "दोन हजार तीस", 2031: "दोन हजार एकतीस", 2032: "दोन हजार बत्तीस", 2033: "दोन हजार तेहतीस", 2034: "दोन हजार चौतीस", 2035: "दोन हजार पस्तीस", 2036: "दोन हजार छत्तीस", 2037: "दोन हजार सदतीस",
      2038: "दोन हजार अडतीस", 2039: "दोन हजार एकोणचाळीस", 2040: "दोन हजार चाळीस", 2041: "दोन हजार एक्केचाळीस", 2042: "दोन हजार बेचाळीस", 2043: "दोन हजार त्रेचाळीस", 2044: "दोन हजार चव्वेचाळीस", 2045: "दोन हजार पंचेचाळीस",
      2046: "दोन हजार सेहेचाळीस", 2047: "दोन हजार सत्तेचाळीस", 2048: "दोन हजार अठ्ठेचाळीस", 2049: "दोन हजार एकोणपन्नास", 2050: "दोन हजार पन्नास", 2051: "दोन हजार एक्कावन्न", 2052: "दोन हजार बावन्न", 2053: "दोन हजार त्रेपन्न",
      2054: "दोन हजार चोपन्न", 2055: "दोन हजार पंचावन्न", 2056: "दोन हजार छप्पन्न", 2057: "दोन हजार सत्तावन्न", 2058: "दोन हजार अठ्ठावन्न", 2059: "दोन हजार एकोणसाठ", 2060: "दोन हजार साठ", 2061: "दोन हजार एकसष्ठ", 2062: "दोन हजार बासष्ठ",
      2063: "दोन हजार त्रेसष्ठ", 2064: "दोन हजार चौसष्ठ", 2065: "दोन हजार पासष्ठ", 2066: "दोन हजार सहासष्ठ", 2067: "दोन हजार सदुसष्ठ", 2068: "दोन हजार अडुसष्ठ", 2069: "दोन हजार एकोणसत्तर", 2070: "दोन हजार सत्तर", 2071: "दोन हजार एक्काहत्तर",
      2072: "दोन हजार बाहत्तर", 2073: "दोन हजार त्र्याहत्तर", 2074: "दोन हजार चौर्‍याहत्तर", 2075: "दोन हजार पंच्याहत्तर", 2076: "दोन हजार शहात्तर", 2077: "दोन हजार सत्याहत्तर", 2078: "दोन हजार अठ्ठ्याहत्तर", 2079: "दोन हजार एकोण ऐंशी",
      2080: "दोन हजार ऐंशी", 2081: "दोन हजार एक्याऐंशी", 2082: "दोन हजार ब्याऐंशी", 2083: "दोन हजार त्र्याऐंशी", 2084: "दोन हजार चौऱ्याऐंशी", 2085: "दोन हजार पंच्याऐंशी", 2086: "दोन हजार शहाऐंशी", 2087: "दोन हजार सत्याऐंशी", 2088: "दोन हजार अठ्याऐंशी", 2089: "दोन हजार एकोणनव्वद", 2090: "दोन हजार नव्वद", 2091: "दोन हजार एक्याण्णव", 2092: "दोन हजार ब्याण्णव", 2093: "दोन हजार त्र्याण्णव", 2094: "दोन हजार चौऱ्याण्णव", 2095: "दोन हजार पंच्याण्णव", 2096: "दोन हजार शहाण्णव", 2097: "दोन हजार सत्त्याण्णव", 2098: "दोन हजार अठ्याण्णव", 2099: "दोन हजार नव्याण्णव", 2100: "एकवीसशे"
    };


    if (schoolLanguage === 'Marathi') {
      const day = dateObj.getDate().toString();
      const dayWord = dayValueInMarathi.find(obj => obj[day])[day];
      const monthIndex = dateObj.getMonth() + 1;
      const year = dateObj.getFullYear().toString();
      if (year < 1970 || year > 2100) {
        return "तारीख उपलब्ध नाही";
      }
      const monthName = monthNamesInMarathi[monthIndex];
      const yearWords = yearValueInMarathi[year];

      return `${dayWord} ${monthName} ${yearWords}`;
    } else {
      const day = dateObj.getDate().toString();
      const dayWord = dayValue.find(obj => obj[day])[day];
      const monthIndex = dateObj.getMonth() + 1;
      const year = dateObj.getFullYear().toString();
      if (year < 1970 || year > 2100) {
        return "Date is not available";
      }
      const monthName = monthNames[monthIndex];
      const yearWords = yearValue[year];

      return `${dayWord} ${monthName} ${yearWords}`;
    }
  }

  const handleDOBChange = (e) => {
    const dob = e.target.value;
    if (!dob) {
      setFormData({ ...formData, dob: '', dobInWords: '' });
      return;
    }
    const dobInWords = convertDateToWords(dob);
    setFormData({ ...formData, dob, dobInWords });
  };



  const districtsData = {
    Maharashtra: [
      schoolLanguage === 'English' ? 'Ahilyanagar' : 'अहिल्यानगर',
      schoolLanguage === 'English' ? 'Akola' : 'अकोला',
      schoolLanguage === 'English' ? 'Amravati' : 'अमरावती',
      schoolLanguage === 'English' ? 'Chh. Sambhajinagar' : 'छ.संभाजीनगर',
      schoolLanguage === 'English' ? 'Beed' : 'बीड',
      schoolLanguage === 'English' ? 'Bhandara' : 'भंडारा',
      schoolLanguage === 'English' ? 'Buldhana' : 'बुलढाणा',
      schoolLanguage === 'English' ? 'Chandrapur' : 'चंद्रपूर',
      schoolLanguage === 'English' ? 'Dhule' : 'धुळे',
      schoolLanguage === 'English' ? 'Gadchiroli' : 'गडचिरोली',
      schoolLanguage === 'English' ? 'Gondia' : 'गोंदिया',
      schoolLanguage === 'English' ? 'Hingoli' : 'हिंगोली',
      schoolLanguage === 'English' ? 'Jalgaon' : 'जळगाव',
      schoolLanguage === 'English' ? 'Jalna' : 'जालना',
      schoolLanguage === 'English' ? 'Kolhapur' : 'कोल्हापूर',
      schoolLanguage === 'English' ? 'Latur' : 'लातूर',
      schoolLanguage === 'English' ? 'Mumbai City' : 'मुंबई शहर',
      schoolLanguage === 'English' ? 'Nagpur' : 'नागपूर',
      schoolLanguage === 'English' ? 'Nanded' : 'नांदेड',
      schoolLanguage === 'English' ? 'Nandurbar' : 'नंदुरबार',
      schoolLanguage === 'English' ? 'Nashik' : 'नाशिक',
      schoolLanguage === 'English' ? 'Dharashiv' : 'धाराशिव',
      schoolLanguage === 'English' ? 'Palghar' : 'पालघर',
      schoolLanguage === 'English' ? 'Parbhani' : 'परभणी',
      schoolLanguage === 'English' ? 'Pune' : 'पुणे',
      schoolLanguage === 'English' ? 'Raigad' : 'रायगड',
      schoolLanguage === 'English' ? 'Ratnagiri' : 'रत्नागिरी',
      schoolLanguage === 'English' ? 'Sangli' : 'सांगली',
      schoolLanguage === 'English' ? 'Satara' : 'सातारा',
      schoolLanguage === 'English' ? 'Sindhudurg' : 'सिंधुदुर्ग',
      schoolLanguage === 'English' ? 'Solapur' : 'सोलापूर',
      schoolLanguage === 'English' ? 'Thane' : 'ठाणे',
      schoolLanguage === 'English' ? 'Wardha' : 'वर्धा',
      schoolLanguage === 'English' ? 'Washim' : 'वाशीम',
      schoolLanguage === 'English' ? 'Yavatmal' : 'यवतमाळ',
    ],
  };
  const talukasData = {
    English: {
      "Kolhapur": ["Karvir", "Panhala", "Shahuwadi", "Kagal", "Hatkanangale", "Shirol", "Radhanagari", "Gaganbawada", "Bhudargad", "Gadhinglaj", "Chandgad", "Ajra"],
      "Sangli": ["Miraj", "Kavathe-Mahankal", "Tasgaon", "Jat", "Walwa (Islampur)", "Shirala", "Khanapur-Vita", "Atpadi", "Palus", "Kadegaon"],
      "Satara": ["Satara", "Jaoli", "Koregaon", "Wai", "Mahabaleshwar", "Khandala", "Phaltan", "Maan (Dahiwadi)", "Khatav (Vaduj)", "Patan", "Karad"],
      "Pune": ["Pune City", "Haveli", "Khed (Rajgurunagar)", "Junnar", "Ambegaon (Ghodegaon)", "Maval (Vadgaon)", "Mulshi (Paud)", "Shirur", "Purandhar (Saswad)", "Velhe", "Bhor", "Baramati", "Indapur", "Daund"],
      "Ahilyanagar": ["Nagar", "Shevgaon", "Pathardi", "Parner", "Sangamner", "Kopargaon", "Akole", "Shrirampur", "Nevasa", "Rahata", "Rahuri", "Shrigonda", "Karjat", "Jamkhed"],
      "Solapur": ["Solapur North", "Barshi", "Solapur South", "Akkalkot", "Madha", "Karmala", "Pandharpur", "Mohol", "Malshiras", "Sangola", "Mangalvedhe"],
      "Dharashiv": ["Dharashiv", "Tuljapur", "Bhum", "Paranda", "Washi", "Kalamb", "Lohara", "Umarga"],
      "Latur": ["Latur", "Renapur", "Ahmedpur", "Jalkot", "Chakur", "Shirur Anantpal", "Ausa", "Nilanga", "Deoni", "Udgir"],
      "Beed": ["Beed", "Ashti", "Patoda", "Shirur-Kasar", "Georai", "Majalgaon", "Wadwani", "Kaij", "Dharur", "Parli", "Ambejogai"],
      "Chh. Sambhajinagar": ["Chh. Sambhajinagar", "Kannad", "Soegaon", "Sillod", "Phulambri", "Khuldabad", "Vaijapur", "Gangapur", "Paithan"],
      "Jalna": ["Jalna", "Bhokardan", "Jafrabad", "Badnapur", "Ambad", "Ghansawangi", "Partur", "Mantha"],
      "Parbhani": ["Parbhani", "Sonpeth", "Gangakhed", "Palam", "Purna", "Sailu", "Jintur", "Manwath", "Pathri"],
      "Hingoli": ["Hingoli", "Sengaon", "Kalamnuri", "Basmath", "Aundha Nagnath"],
      "Nanded": ["Nanded", "Ardhapur", "Mudkhed", "Bhokar", "Umri", "Loha", "Kandhar", "Kinwat", "Himayatnagar", "Hadgaon", "Mahur", "Deglur", "Mukhed", "Dharmabad", "Biloli", "Naigaon (Khairgaon)"],
      "Yavatmal": ["Yavatmal", "Arni", "Babhulgaon", "Kalamb", "Darwha", "Digras", "Ner", "Pusad", "Umarkhed", "Mahagaon", "Kelapur (Pandharkawada)", "Ralegaon", "Ghatanji", "Wani", "Maregaon", "Zari Jamani"],
      "Chandrapur": ["Chandrapur", "Saoli", "Mul", "Ballarpur", "Pombhurna", "Gondpimpri", "Warora", "Chimur", "Bhadravati", "Bramhapuri", "Nagbhid", "Sindewahi", "Rajura", "Korpana", "Jivati"],
      "Gadchiroli": ["Gadchiroli", "Dhanora", "Chamorshi", "Mulchera", "Desaiganj (Vadasa)", "Armori", "Kurkheda", "Korchi", "Aheri", "Bhamragad", "Sironcha"],
      "Gondia": ["Gondia", "Tirora", "Goregaon", "Arjuni Morgaon", "Amgaon", "Salekasa", "Sadak Arjuni", "Deori"],
      "Bhandara": ["Bhandara", "Tumsar", "Pauni", "Mohadi", "Sakoli", "Lakhni", "Lakhandur"],
      "Nagpur": ["Nagpur (Urban)", "Nagpur (Rural)", "Kamptee", "Hingna", "Katol", "Narkhed", "Savner", "Kalameshwar", "Ramtek", "Mouda", "Parseoni", "Umred", "Kuhi", "Bhiwapur"],
      "Wardha": ["Wardha", "Deoli", "Seloo", "Arvi", "Ashti", "Karanja", "Hinganghat", "Samudrapur"],
      "Amravati": ["Amravati", "Bhatukali", "Nandgaon Khandeshwar", "Dharni (Amravati)", "Chikhaldara", "Achalpur", "Chandurbazar", "Morshi", "Warud", "Daryapur", "Anjangaon-Surji", "Chandur", "Dhamangaon", "Tiosa"],
      "Washim": ["Washim", "Malegaon", "Risod", "Mangrulpir", "Karanja", "Manora"],
      "Akola": ["Akola", "Akot", "Telhara", "Balapur", "Patur", "Murtajapur", "Barshitakli"],
      "Buldhana": ["Buldhana", "Chikhli", "Deulgaon Raja", "Jalgaon Jamod", "Sangrampur", "Malkapur", "Motala", "Nandura", "Khamgaon", "Shegaon", "Mehkar", "Sindkhed Raja", "Lonar"],
      "Jalgaon": ["Jalgaon", "Jamner", "Erandol", "Dharangaon", "Bhusawal", "Raver", "Muktainagar (Edalabad)", "Bodwad", "Yawal", "Amalner", "Parola", "Chopda", "Pachora", "Bhadgaon", "Chalisgaon"],
      "Dhule": ["Dhule", "Sakri", "Sindkheda", "Shirpur"],
      "Nandurbar": ["Nandurbar", "Navapur", "Shahada", "Taloda", "Akkalkuwa", "Akrani (Dhadgaon)"],
      "Nashik": ["Nashik", "Igatpuri", "Dindori", "Peth", "Trimbakeshwar", "Kalwan", "Deola", "Surgana", "Baglan", "Malegaon", "Nandgaon", "Chandwad", "Niphad", "Sinnar", "Yeola"],
      "Palghar": ["Palghar", "Vasai", "Dahanu", "Talasari", "Jawhar", "Mokhada", "Vada", "Vikramgad"],
      "Thane": ["Thane", "Kalyan", "Murbad", "Bhiwandi", "Shahapur", "Ulhasnagar", "Ambarnath"],
      "Mumbai City": ["Kurla", "Andheri", "Borivali"],
      "Raigad": ["Pen", "Alibaug", "Murud", "Panvel", "Uran", "Karjat (Matheran)", "Khalapur", "Mangaon", "Tala", "Roha", "Sudhagad (Pali)", "Mahad", "Poladpur", "Shrivardhan", "Mhasla"],
      "Ratnagiri": ["Ratnagiri", "Sangameshwar (Deorukh)", "Lanja", "Rajapur", "Chiplun", "Guhagar", "Dapoli", "Mandangad", "Khed"],
      "Sindhudurg": ["Kankavli", "Vaibhavwadi", "Devgad", "Malwan", "Sawantwadi", "Kudal", "Vengurla", "Dodamarg (Kasal)"]
    },
    Marathi: {
      "कोल्हापूर": ["करवीर", "पन्हाळा", "शाहूवाडी", "कागल", "हातकणंगले", "शिरोळ", "राधानगरी", "गगनबावडा", "भुदरगड", "गढिंगलज", "चंदगड", "आजरा"],
      "सांगली": ["मिरज", "कवठे-महांकळ", "तासगाव", "जत", "वाळवा (इस्लामपुर)", "शिराळा", "खानापूर-विटा", "आटपाडी", "पळूस", "कडेगाव"],
      "सातारा": ["सातारा", "जावळी", "कोरेगाव", "वाई", "महाबळेश्वर", "खंडाळा", "फलटण", "माण (दहिवडी)", "खताव (वडुज)", "पाटण", "कराड"],
      "पुणे": ["पुणे शहर", "हवेली", "खेड (राजगुरुनगर)", "जुन्नर", "अंबेगाव (घोडेगाव)", "मावळ (वडगाव)", "मुळशी (पाऊड)", "शिरूर", "पुरंधर (सस्वद)", "वेल्हे", "भोर", "बारामती", "इंदापूर", "दौंड"],
      "अहिल्यानगर": ["नगर", "शेवगाव", "पाठार्डी", "परनेर", "संगमनेर", "कोपरगाव", "अकोले", "श्रीरामपुर", "नेवासा", "राहता", "राहुरी", "श्रीगोंडा", "कर्जत", "जामखेड"],
      "सोलापूर": ["सोलापूर उत्तर", "बार्शी", "सोलापूर दक्षिण", "अक्कलकोट", "मधा", "करमाळा", "पंढरपूर", "मोहोळ", "माळशिरस", "सांगोळ", "मंगळवेढे"],
      "धाराशिव": ["धाराशिव", "तुळजापूर", "भूम", "परंदा", "वाशी", "कलंब", "लोहारा", "उमरगा"],
      "लातूर": ["लातूर", "रेणापूर", "अहमदपूर", "जळकोट", "चाकूर", "शिरूर अनंतपाळ", "औसा", "निळंगा", "देवनी", "उदगीर"],
      "बीड": ["बीड", "अश्ती", "पाटोदा", "शिरूर-कासर", "गेवराई", "मजलगाव", "वडवाणी", "कईज", "धरूर", "पारळी", "आंबेजोगाई"],
      "छ.संभाजीनगर": ["छ.संभाजीनगर", "कानंद", "सोईगाव", "सिल्लोड", "फुलंब्री", "खुलदाबाद", "वैजापूर", "गंगापूर", "पैठण"],
      "जालना": ["जालना", "भोकरदान", "जाफराबाद", "बडनापूर", "अंबाड", "घांसावंगी", "परटूर", "मंथा"],
      "परभणी": ["परभणी", "सोनपेठ", "गंगाखेड", "पाळम", "पूर्णा", "साईलू", "जिंतूर", "मनवठ", "पथरी"],
      "हिंगोली": ["हिंगोली", "सेंगाव", "कळमनुरी", "बासमत", "औंधा नागनाथ"],
      "नांदेड": ["नांदेड", "अर्धापूर", "मुदखेड", "भोकर", "उमरी", "लोहा", "कांधार", "किंवट", "हिमायतनगर", "हडगाव", "महूर", "देगळूर", "मुखेड", "धर्माबाद", "बिलोळी", "नागांव (खैरगांव)"],
      "यवतमाळ": ["यवतमाळ", "अर्णी", "बभुलगाव", "कळम्ब", "दारव्हा", "दिग्रास", "नेर", "पुसड", "उमरखेड", "महागाव", "केळापूर (पांढरकवाडा)", "राळेगाव", "घटांजी", "वाणी", "मारेगाव", "जारी जामानी"],
      "चंद्रपूर": ["चंद्रपूर", "सावली", "मुळ", "बल्लारपूर", "पोंभूर्णा", "गोंदपिंपरी", "वरोरा", "चिमूर", "भद्रावती", "ब्रह्मपूरी", "नागभिड", "सिंडेवाही", "राजूरा", "कोरपाणा", "जिवती"],
      "गडचिरोली": ["गडचिरोली", "धनोरा", "चामोर्शी", "मुलचेरा", "देसैगंज (वडसा)", "आरमोरी", "कुरखेडा", "कोरची", "आहेरी", "भामरगाव", "सिरोंचा"],
      "गोंदिया": ["गोंदिया", "तिरोरा", "गोरेगाव", "अर्जुनी मोरगाव", "अमगाव", "साळेकासा", "सडक अर्जुनी", "देओरी"],
      "भंडारा": ["भंडारा", "तुमसार", "पाऊनी", "मोहडी", "साकोळी", "लाखनी", "लाखांदुर"],
      "नागपूर": ["नागपूर (शहरी)", "नागपूर (ग्रामीण)", "कामठी", "हिंगणा", "कटोल", "नारखेड", "सावनेर", "काळामेश्वर", "रामटेक", "मौडा", "परसेवनी", "उमरेड", "कुही", "भिवापूर"],
      "वर्धा": ["वर्धा", "देवोली", "सेलू", "अरवी", "अश्ती", "कारंजा", "हिंगणघाट", "समुद्रापूर"],
      "अमरावती": ["अमरावती", "भाटुकली", "नंदगाव कांदेश्वर", "धरणी (अमरावती)", "चिखलदारा", "आचलपूर", "चंदूरबाजार", "मोरशी", "वारुड", "दर्यापूर", "अंजनगाव-सुर्जी", "चंदूर", "धामांगाव", "तिओसा"],
      "वाशिम": ["वाशिम", "माळेगाव", "रिसोड", "मांगरुलपीर", "करंजा", "मनोरा"],
      "अकोला": ["अकोला", "अकोट", "टेलहारा", "बालापूर", "पाटूर", "मुर्ताजापूर", "बर्शितकली"],
      "बुलढाणा": ["बुलढाणा", "चिखली", "देऊलगाव राजा", "जळगाव जामोद", "संग्रामपुर", "माळकापूर", "मोतला", "नांदुरा", "खामगाव", "शेगाव", "मेहकर", "सिंधखेड राजा", "लोणार"],
      "जळगाव": ["जळगाव", "जामनेर", "इरंडोल", "धारणगाव", "भुसावळ", "रावेर", "मुक्तैनगर (एडलाबाद)", "बोडवाड", "यावळ", "अमळनेर", "परोळा", "चोपडा", "पाचोरा", "भडगाव", "चाळीसगाव"],
      "धुळे": ["धुळे", "साकरी", "सिंधखेडा", "शिरपूर"],
      "नंदुरबार": ["नंदुरबार", "नवापूर", "शहादा", "तालोदा", "अक्कलकुवा", "अकरणी (धडगाव)"],
      "नाशिक": ["नाशिक", "इगतपुरी", "दिंडोरी", "पेठ", "त्रिंबकेश्वर", "कलवाण", "देवळा", "सुरगाणा", "बागलाण", "माळेगाव", "नांदगाव", "चांदवड", "निफड", "सिन्नार", "येवोळा"],
      "पालघर": ["पालघर", "वसई", "दहाणू", "तळसारी", "जावहर", "मोखाडा", "वडा", "विक्रमगड"],
      "ठाणे": ["ठाणे", "कल्याण", "मुरबाड", "भिवंडी", "शहापूर", "उल्हासनगर", "अंबरनाथ"],
      "मुंबई शहर": ["कुर्ला", "अंधेरी", "बोरिवली"],
      "रायगड": ["पेण", "आळीबाग", "मुरुड", "पनवेल", "उरण", "कर्जत (माथेराण)", "खालापूर", "मंगाव", "ताळा", "रोहा", "सुधागड (पाळी)", "महाड", "पोलडपूर", "श्रीवर्धन", "म्हासळा"],
      "रत्नागिरी": ["रत्नागिरी", "संगमेश्वर (देवरुख)", "लांजा", "राजापूर", "चिपळूण", "गुहागर", "दापोळी", "मंडणगड", "खेड"],
      "सिंधुदुर्ग": ["कणकवली", "वैभववाडी", "देवगड", "मालवण", "सावंतवाडी", "कुडाळ", "वेंगुर्ला", "दोडमर्ग (कसाळ)"]
    }
  };


  const handleDistrictChange = (event) => {
    const district = event.target.value;
    setFormData({
      ...formData,
      district: district,
      taluka: "",
    });
  };

  const handleTalukaChange = (event) => {
    const taluka = event.target.value;

    setFormData({
      ...formData,
      taluka: taluka,
    });
  };

  const talukaOptions = formData.district && (
    schoolLanguage === 'English' ?
      talukasData['English'][formData.district]?.map((taluka, index) => (
        <option key={index} value={taluka}>{taluka}</option>
      ))
      :
      talukasData['Marathi'][formData.district]?.map((taluka, index) => (
        <option key={index} value={taluka}>{taluka}</option>
      ))
  );

  const handleCountryChange = (event) => {
    const selectedValue = event.target.value;
    setFormData({
      ...formData,
      country: selectedValue,
    });
  };





  const printForm = () => {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';

    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    doc.open();
    doc.write(`
    <html>
      <head>
        <title>Admission Form</title>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');
          
          body {
            font-family: 'Poppins', sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f5f7fa;
            color: #333;
            line-height: 1.6;
          }
          
          .container {
            width: 210mm;
            min-height: 297mm;
            margin: 0 auto;
            padding: 15mm;
            background: white;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          }
          
          .header {
            text-align: center;
            margin-bottom: 20px;
            border-bottom: 2px solid #3f51b5;
            padding-bottom: 15px;
            position: relative;
          }
          
          .school-logo {
            height: 80px;
            margin-bottom: 10px;
          }
          
          h1 {
            color: #3f51b5;
            margin: 5px 0;
            font-size: 28px;
            font-weight: 600;
          }
          
          h2 {
            color: #555;
            margin: 5px 0;
            font-size: 22px;
            font-weight: 500;
          }
          
          .school-info {
            color: #666;
            font-size: 14px;
            margin: 5px 0;
          }
          
          .form-section {
            margin-bottom: 20px;
            page-break-inside: avoid;
          }
          
          .section-title {
            background-color: #3f51b5;
            color: white;
            padding: 8px 15px;
            margin: 15px 0 10px 0;
            font-size: 16px;
            font-weight: 500;
            border-radius: 4px;
          }
          
          .form-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
            gap: 10px;
          }
          
          .form-field {
            margin-bottom: 8px;
            display: flex;
            align-items: flex-start;
          }
          
          .form-field label {
            font-weight: 500;
            color: #555;
            min-width: 180px;
            display: inline-block;
          }
          
          .form-field .value {
            flex: 1;
            word-break: break-word;
          }
          
          .student-photo {
            float: right;
            margin: 0 0 15px 15px;
            border: 1px solid #ddd;
            padding: 3px;
            width: 100px;
            height: 120px;
            object-fit: cover;
          }
          
          .watermark {
            position: absolute;
            opacity: 0.1;
            font-size: 80px;
            font-weight: bold;
            color: #3f51b5;
            transform: rotate(-30deg);
            top: 50%;
            left: 20%;
            z-index: -1;
          }
          
          @media print {
            body {
              background: none;
            }
            .container {
              box-shadow: none;
              padding: 0;
              width: auto;
            }
            .watermark {
              opacity: 0.15;
            }
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="watermark">${schoolData.schoolName?.substring(0, 10) || 'ADMISSION'}</div>
          
          <div class="header">
            ${schoolData.schoolLogo && `
              <img src="${schoolData.schoolLogo}" alt="School Logo" class="school-logo">
            `}
            <h1>${schoolLanguage === 'English' ? "Admission Form" : "प्रवेश अर्ज"}</h1>
            <h2>${schoolData.schoolName || ""}</h2>
            <div class="school-info">${schoolData.address || ""}</div>
            <div class="school-info">
              ${schoolLanguage === 'English' ? "Taluka" : "तालुका"}: ${schoolData.taluka || ""}, 
              ${schoolLanguage === 'English' ? "District" : "जिल्हा"}: ${schoolData.district || ""}
            </div>
          </div>
           
          <div class="form-section">
            <div class="section-title">${schoolLanguage === 'English' ? "Basic Information" : "बेसिक माहिती"}</div>
            <div class="form-grid">
              <div class="form-field">
                <label>APAR ID:</label>
                <div class="value">${formData.aparId || ""}</div>
              </div>
              <div class="form-field">
                <label>PAN ID:</label>
                <div class="value">${formData.panId || ""}</div>
              </div>
              <div class="form-field">
                <label>Educational Year:</label>
                <div class="value">${formData.educationalYear || ""}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${schoolLanguage === 'English' ? "Personal Information" : "वैयक्तिक माहिती"}</div>
            <img src="${formData.stdPhoto || ""}" alt="Student Photo" class="student-photo">
            <div class="form-grid">
              <div class="form-field">
                <label>Surname:</label>
                <div class="value">${formData.stdSurname || ""}</div>
              </div>
              <div class="form-field">
                <label>Student's Name:</label>
                <div class="value">${formData.stdName || ""}</div>
              </div>
              <div class="form-field">
                <label>Father's Name:</label>
                <div class="value">${formData.stdFather || ""}</div>
              </div>
              <div class="form-field">
                <label>Mother's Name:</label>
                <div class="value">${formData.stdMother || ""}</div>
              </div>
              <div class="form-field">
                <label>Aadhar Number:</label>
                <div class="value">${formData.stdAdharNo || ""}</div>
              </div>
              <div class="form-field">
                <label>Gender:</label>
                <div class="value">${formData.gender || ""}</div>
              </div>
              <div class="form-field">
                <label>Date of Birth:</label>
                <div class="value">${formData.dob || ""}</div>
              </div>
              <div class="form-field">
                <label>Birth Place:</label>
                <div class="value">${formData.birthPlace || ""}</div>
              </div>
              <div class="form-field">
                <label>Blood Group:</label>
                <div class="value">${formData.bloodGroup || ""}</div>
              </div>
              <div class="form-field">
                <label>Birthmark:</label>
                <div class="value">${formData.birthmark || ""}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${schoolLanguage === 'English' ? "Demographic Information" : "लोकसंख्यात्मक माहिती"}</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Religion:</label>
                <div class="value">${formData.religion || ""}</div>
              </div>
              <div class="form-field">
                <label>Caste:</label>
                <div class="value">${formData.caste || ""}</div>
              </div>
              <div class="form-field">
                <label>Sub-Caste:</label>
                <div class="value">${formData.subCaste || ""}</div>
              </div>
              <div class="form-field">
                <label>Category:</label>
                <div class="value">${formData.category || ""}</div>
              </div>
              <div class="form-field">
                <label>Nationality:</label>
                <div class="value">${formData.nationality || ""}</div>
              </div>
              <div class="form-field">
                <label>Mother Tongue:</label>
                <div class="value">${formData.motherTounge || ""}</div>
              </div>
              <div class="form-field">
                <label>Is Minority:</label>
                <div class="value">${formData.isMinority ? "Yes" : "No"}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${schoolLanguage === 'English' ? "Location Information" : "पत्ता माहिती"}</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Country:</label>
                <div class="value">${formData.country || ""}</div>
              </div>
              <div class="form-field">
                <label>State:</label>
                <div class="value">${formData.state || ""}</div>
              </div>
              <div class="form-field">
                <label>District:</label>
                <div class="value">${formData.district || ""}</div>
              </div>
              <div class="form-field">
                <label>Taluka:</label>
                <div class="value">${formData.taluka || ""}</div>
              </div>
              <div class="form-field">
                <label>Full Address:</label>
                <div class="value">${formData.address || ""}</div>
              </div>
              <div class="form-field">
                <label>Pincode:</label>
                <div class="value">${formData.pincode || ""}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${schoolLanguage === 'English' ? "Contact Information" : "संपर्क माहिती"}</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Student Mobile No.:</label>
                <div class="value">${formData.mobileNo || ""}</div>
              </div>
              <div class="form-field">
                <label>Father's Mobile No.:</label>
                <div class="value">${formData.fMobile || ""}</div>
              </div>
              <div class="form-field">
                <label>Mother's Mobile No.:</label>
                <div class="value">${formData.mMobile || ""}</div>
              </div>
              <div class="form-field">
                <label>Aadhar Linked Mobile No.:</label>
                <div class="value">${formData.adharmobileNo || ""}</div>
              </div>
             
            </div>
             <div class="form-field">
                <label>Student Email ID:</label>
                <span class="value">${formData.stdemailId || ""}</span>
              </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${schoolLanguage === 'English' ? "Parent's Occupation" : "पालकांची माहिती"}</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Father's Occupation:</label>
                <div class="value">${formData.fOccupation || ""}</div>
              </div>
              <div class="form-field">
                <label>Mother's Occupation:</label>
                <div class="value">${formData.mOccupation || ""}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${schoolLanguage === 'English' ? "Education Information" : "शैक्षणिक माहिती"}</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Previous School:</label>
                <div class="value">${formData.prevSchool || ""}</div>
              </div>
              <div class="form-field">
                <label>Admission Class:</label>
                <div class="value">${formData.currentClass || ""}</div>
              </div>
              <div class="form-field">
                <label>Date of Admission:</label>
                <div class="value">${formData.dateOfAdmission || ""}</div>
              </div>
            </div>
          </div>
          
          <div class="form-section">
            <div class="section-title">${schoolLanguage === 'English' ? "Bank Information" : "बँकेची माहिती"}</div>
            <div class="form-grid">
              <div class="form-field">
                <label>Account Holder Name:</label>
                <div class="value">${formData.accHolderName || ""}</div>
              </div>
              <div class="form-field">
                <label>Account Number:</label>
                <div class="value">${formData.accNo || ""}</div>
              </div>
              <div class="form-field">
                <label>Bank Name:</label>
                <div class="value">${formData.bankName || ""}</div>
              </div>
              <div class="form-field">
                <label>Branch Name:</label>
                <div class="value">${formData.branchName || ""}</div>
              </div>
              <div class="form-field">
                <label>IFSC Code:</label>
                <div class="value">${formData.IFSC || ""}</div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </html>
  `);
    doc.close();

    iframe.onload = function () {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      }, 500); // Give time to load styles/images
    };
  };




  const downloadPDF = async () => {
    // Create a temporary div to hold the content
    const pdfContent = document.createElement('div');
    pdfContent.style.width = '210mm';
    pdfContent.style.minHeight = '297mm';
    pdfContent.style.padding = '15mm';
    pdfContent.style.background = 'white';
    pdfContent.style.position = 'absolute';
    pdfContent.style.left = '-9999px';
    pdfContent.style.fontFamily = "'Poppins', sans-serif";
    pdfContent.style.fontSize = '12px'; // Reduced font size
    pdfContent.style.lineHeight = '1.4'; // Reduced line height

    // Add the complete HTML content with optimized styling
    pdfContent.innerHTML = `
    <div style="font-family: 'Poppins', sans-serif; margin: 0; padding: 0; color: #333; line-height: 1.4; font-size: 12px;">
      <!-- Removed watermark to reduce complexity -->
      
      <div class="header" style="text-align: center; margin-bottom: 15px; border-bottom: 1px solid #3f51b5; padding-bottom: 10px;">
        <h1 style="color: #3f51b5; margin: 5px 0; font-size: 20px; font-weight: 600;">
          ${schoolLanguage === 'English' ? "Admission Form" : "प्रवेश अर्ज"}
        </h1>
        <h2 style="color: #555; margin: 5px 0; font-size: 16px; font-weight: 500;">
          ${schoolData.schoolName || ""}
        </h2>
        <div style="color: #666; font-size: 11px; margin: 3px 0;">
          ${schoolData.address || ""}
        </div>
        <div style="color: #666; font-size: 11px; margin: 3px 0;">
          ${schoolLanguage === 'English' ? "Taluka" : "तालुका"}: ${schoolData.taluka || ""}, 
          ${schoolLanguage === 'English' ? "District" : "जिल्हा"}: ${schoolData.district || ""}
        </div>
      </div>


      <!-- Basic Information -->
      <div style="margin-bottom: 15px;">
        <div style="background-color: #3f51b5; color: white; padding: 5px 10px; margin: 10px 0 8px 0; font-size: 13px; font-weight: 500;">
          ${schoolLanguage === 'English' ? "Basic Information" : "बेसिक माहिती"}
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>APAR ID:</strong> ${formData.aparId || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>PAN ID:</strong> ${formData.panId || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Educational Year:</strong> ${formData.educationalYear || ""}
          </div>
        </div>
      </div>
      
      <!-- Personal Information -->
      <div style="margin-bottom: 15px;">
        <div style="background-color: #3f51b5; color: white; padding: 5px 10px; margin: 10px 0 8px 0; font-size: 13px; font-weight: 500;">
          ${schoolLanguage === 'English' ? "Personal Information" : "वैयक्तिक माहिती"}
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Surname:</strong> ${formData.stdSurname || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Student's Name:</strong> ${formData.stdName || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Father's Name:</strong> ${formData.stdFather || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Mother's Name:</strong> ${formData.stdMother || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Aadhar Number:</strong> ${formData.stdAdharNo || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Gender:</strong> ${formData.gender || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Date of Birth:</strong> ${formData.dob || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Birth Place:</strong> ${formData.birthPlace || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Blood Group:</strong> ${formData.bloodGroup || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Birthmark:</strong> ${formData.birthmark || ""}
          </div>
        </div>
      </div>
      
      <!-- Demographic Information -->
      <div style="margin-bottom: 15px;">
        <div style="background-color: #3f51b5; color: white; padding: 5px 10px; margin: 10px 0 8px 0; font-size: 13px; font-weight: 500;">
          ${schoolLanguage === 'English' ? "Demographic Information" : "जनसांख्यिकीय माहिती"}
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Religion:</strong> ${formData.religion || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Caste:</strong> ${formData.caste || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Sub-Caste:</strong> ${formData.subCaste || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Category:</strong> ${formData.category || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Nationality:</strong> ${formData.nationality || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Mother Tongue:</strong> ${formData.motherTounge || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Is Minority:</strong> ${formData.isMinority ? "Yes" : "No"}
          </div>
        </div>
      </div>
      
      <!-- Location Information -->
      <div style="margin-bottom: 15px;">
        <div style="background-color: #3f51b5; color: white; padding: 5px 10px; margin: 10px 0 8px 0; font-size: 13px; font-weight: 500;">
          ${schoolLanguage === 'English' ? "Location Information" : "पत्ता माहिती"}
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Country:</strong> ${formData.country || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>State:</strong> ${formData.state || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>District:</strong> ${formData.district || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Taluka:</strong> ${formData.taluka || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Full Address:</strong> ${formData.address || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Pincode:</strong> ${formData.pincode || ""}
          </div>
        </div>
      </div>
      
      <!-- Contact Information -->
      <div style="margin-bottom: 15px;">
        <div style="background-color: #3f51b5; color: white; padding: 5px 10px; margin: 10px 0 8px 0; font-size: 13px; font-weight: 500;">
          ${schoolLanguage === 'English' ? "Contact Information" : "संपर्क माहिती"}
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Student Mobile No.:</strong> ${formData.mobileNo || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Father's Mobile No.:</strong> ${formData.fMobile || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Mother's Mobile No.:</strong> ${formData.mMobile || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Aadhar Linked Mobile No.:</strong> ${formData.adharmobileNo || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Student Email ID:</strong> ${formData.stdemailId || ""}
          </div>
        </div>
      </div>
      
      <!-- Parent's Occupation -->
      <div style="margin-bottom: 15px;">
        <div style="background-color: #3f51b5; color: white; padding: 5px 10px; margin: 10px 0 8px 0; font-size: 13px; font-weight: 500;">
          ${schoolLanguage === 'English' ? "Parent's Occupation" : "पालकांची माहिती"}
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Father's Occupation:</strong> ${formData.fOccupation || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Mother's Occupation:</strong> ${formData.mOccupation || ""}
          </div>
        </div>
      </div>
      
      <!-- Education Information -->
      <div style="margin-bottom: 15px;">
        <div style="background-color: #3f51b5; color: white; padding: 5px 10px; margin: 10px 0 8px 0; font-size: 13px; font-weight: 500;">
          ${schoolLanguage === 'English' ? "Education Information" : "शैक्षणिक माहिती"}
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Previous School:</strong> ${formData.prevSchool || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Admission Class:</strong> ${formData.currentClass || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Date of Admission:</strong> ${formData.dateOfAdmission || ""}
          </div>
        </div>
      </div>
      
      <!-- Bank Information -->
      <div style="margin-bottom: 15px;">
        <div style="background-color: #3f51b5; color: white; padding: 5px 10px; margin: 10px 0 8px 0; font-size: 13px; font-weight: 500;">
          ${schoolLanguage === 'English' ? "Bank Information" : "बँकेची माहिती"}
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Account Holder Name:</strong> ${formData.accHolderName || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Account Number:</strong> ${formData.accNo || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Bank Name:</strong> ${formData.bankName || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>Branch Name:</strong> ${formData.branchName || ""}
          </div>
          <div style="flex: 1; min-width: 200px; margin-bottom: 5px;">
            <strong>IFSC Code:</strong> ${formData.IFSC || ""}
          </div>
        </div>
      </div>
    </div>
  `;

    // Append to body
    document.body.appendChild(pdfContent);

    try {
      // Optimized html2canvas options
      const canvas = await html2canvas(pdfContent, {
        scale: 1.5, // Reduced from 2 to 1.5
        logging: false,
        useCORS: true,
        allowTaint: true,
        scrollX: 0,
        scrollY: 0,
        backgroundColor: '#ffffff',
        removeContainer: true,
        // Optimize for smaller size
        imageTimeout: 0,
        foreignObjectRendering: false
      });

      // Compress the image before adding to PDF
      const tempCanvas = document.createElement('canvas');
      const tempCtx = tempCanvas.getContext('2d');
      tempCanvas.width = canvas.width;
      tempCanvas.height = canvas.height;

      // Draw with compression
      tempCtx.drawImage(canvas, 0, 0);

      // Convert to JPEG with compression (smaller than PNG)
      const imgData = tempCanvas.toDataURL('image/jpeg', 0.8); // 80% quality

      // Create PDF with optimized settings
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        compress: true // Enable PDF compression
      });

      const imgWidth = 210; // A4 width in mm
      const pageHeight = 295; // A4 height in mm
      const imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      // Add image to PDF
      pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight, undefined, 'MEDIUM');
      heightLeft -= pageHeight;

      // Add additional pages if needed
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight, undefined, 'MEDIUM');
        heightLeft -= pageHeight;
      }

      // Save the PDF
      pdf.save(`${formData.stdName || 'student'}_admission_form.pdf`);

    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    } finally {
      // Remove the temporary div
      document.body.removeChild(pdfContent);
    }
  };




  //  const generatePDF = () => {
  //     const printContent = document.getElementById('formContent').innerHTML; // Get the form content
  //     const pdfWindow = window.open('', '_blank'); // Open a new window
  //     pdfWindow.document.write(`
  //       <html>
  //         <head>
  //           <title>Admission Form</title>
  //           <style>
  //             body { font-family: Arial, sans-serif; }
  //             h1, h2 { text-align: center; }
  //             .form-section { margin: 20px; }
  //             .form-field { margin-bottom: 10px; }
  //           </style>
  //         </head>
  //         <body>
  //           <h1>Admission Form</h1>
  //           <div>${printContent}</div>
  //         </body>
  //       </html>
  //     `);
  //     pdfWindow.document.close(); // Close the document
  //     // Wait for the content to load before triggering the download
  //     pdfWindow.onload = function() {
  //       pdfWindow.print(); // Trigger the print dialog
  //       pdfWindow.close(); // Close the window after printing
  //     };
  //   };





  return (
    <div style={{
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      minHeight: '100vh',
      padding: '2rem 1rem'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        background: 'white',
        borderRadius: '15px',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
      }} >

        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '2rem',
          color: 'white',
          position: 'relative',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }} className='adm-head'>

          <div style={{ flex: '0 0 auto' }}>
            <img className='schlogo' src={schoolData.schoolLogo || ''} alt="logo"
              style={{ width: '100px', height: '100px', objectFit: 'contain', borderRadius: '8px', backgroundColor: '#fff' }} />
          </div>

          <div style={{ textAlign: 'center', maxWidth: '700px' }} className='header-sch'>
            <h1 style={{
              fontSize: '2.5rem',
              fontWeight: '700',
            }}>{schoolLanguage === 'English' ? "Admission Form" : "प्रवेश अर्ज"}</h1>

            <div class="center-line">
              <span class="line"></span>
              <span class="dot"></span>
              <span class="line"></span>
            </div>

            <h2 style={{ fontWeight: 'bold', color: '#ffc107', marginTop: '20px' }}>
              {schoolData.schoolName || "Loading..."}
            </h2>
            <p style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#ffc107' }}>
              {schoolData.address || ""}
              <br />
              {schoolLanguage === 'English' ? "Taluka" : "तालुका"}:  {schoolData.taluka || ""},  {schoolLanguage === 'English' ? "District" : "जिल्हा"}: {schoolData.jilha || ""}
            </p>
          </div>
          <style jsx>{`
              .center-line {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                margin-top:-4px;
              }

              .center-line .line {
                height: 2px;
                width: 50px;
                background: #ffffff;
                opacity: 0.8;
              }

              .center-line .dot {
                width: 10px;
                height: 10px;
                background: #ffffff;
                border-radius: 50%;
                box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
              }
              `}</style>


        </div>

        {submitMessage && (
          <div style={{
            margin: '1rem',
            padding: '1rem',
            background: '#d1fae5',
            color: '#065f46',
            borderRadius: '8px',
            borderLeft: '4px solid #10b981'
          }}>
            {submitMessage}
          </div>
        )}

        {submitError && (
          <div style={{
            margin: '1rem',
            padding: '1rem',
            background: '#fee2e2',
            color: '#b91c1c',
            borderRadius: '8px',
            borderLeft: '4px solid #ef4444'
          }}>
            {submitError}
          </div>
        )}

        <p style={{ marginTop: '10px', marginBottom: '20px', fontSize: '12px', textAlign: 'left', marginLeft: '10px' }}> Required fields are indicated with an asterisk (<span style={{ color: 'red' }}>*</span>).</p>
        <form onSubmit={handleSubmit} style={{ padding: '2rem' }}>

          <div style={{ marginBottom: '2.5rem' }} id='formContent'>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '1.5rem',
              paddingBottom: '0.5rem',
              borderBottom: '2px solid #e5e7eb'
            }}>{schoolLanguage === 'English' ? "Basic Information" : "बेसिक माहिती"}</h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.5rem'
            }}>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "APAR ID" : "विद्यार्थी अपार आयडी"}</label>
                <input
                  type="text"
                  name="aparId"
                  value={formData.aparId}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "PAN ID" : "विद्यार्थी PEN"}</label>
                <input
                  type="text"
                  name="panId"
                  value={formData.panId}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>
                  {schoolLanguage === 'English' ? "Educational Year" : "शैक्षणिक वर्ष"}
                </label>

                <select
                  name="educationalYear"
                  value={formData.educationalYear}
                  onChange={handleChange}
                  disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                >
                  <option value="">-- {schoolLanguage === 'English' ? "Select Year" : "वर्ष निवडा"} --</option>
                  <option value="2023-2024">2023-2024</option>
                  <option value="2024-2025">2024-2025</option>
                  <option value="2025-2026">2025-2026</option>
                  <option value="2026-2027">2026-2027</option>
                  <option value="2027-2028">2027-2028</option>
                  <option value="2027-2028">2028-2029</option>
                </select>
              </div>

            </div>
          </div>

          {/* Education Information Section */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '1.5rem',
              paddingBottom: '0.5rem',
              borderBottom: '2px solid #e5e7eb'
            }}>{schoolLanguage === 'English' ? "Education Information" : "शैक्षणिक माहिती"}</h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.5rem'
            }}>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>
                  Admission Class <span style={{ color: 'red' }}>*</span>
                </label>
                <select
                  name="currentClass"
                  value={formData.currentClass}
                  onChange={handleChange} // Update the formData when a class is selected
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                >
                  <option value="" disabled>Select a class</option> {/* Placeholder option */}
                  {classes.map((classItem, index) => (
                    <option key={index} value={classItem.name}>
                      {classItem.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Date of Admission" : "प्रवेशाची तारीख"}</label>
                <input
                  type="date"
                  name="dateOfAdmission"
                  value={formData.dateOfAdmission}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Previous School" : "या पूर्वीची शाळा"}</label>
                <input
                  type="text"
                  name="prevSchool"
                  value={formData.prevSchool}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>

            </div>
          </div>


          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '1.5rem',
              paddingBottom: '0.5rem',
              borderBottom: '2px solid #e5e7eb'
            }}>{schoolLanguage === 'English' ? "Personal Information" : "वैयक्तिक माहिती"}</h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.5rem'
            }}>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Surname" : "आडनाव"} <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="stdSurname"
                  value={formData.stdSurname}
                  onChange={handleChange} disabled={isSubmitted}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Student's Name" : "विद्यार्थ्याचे नाव"} <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="stdName"
                  value={formData.stdName}
                  onChange={handleChange} disabled={isSubmitted}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Father's Name" : "वडीलांचे नाव"} <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="stdFather"
                  value={formData.stdFather}
                  onChange={handleChange} disabled={isSubmitted}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Mother's Name" : "आईचे नाव"} <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="stdMother"
                  value={formData.stdMother}
                  onChange={handleChange} disabled={isSubmitted}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Aadhar Number" : "आधार कार्ड क्र."} <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="stdAdharNo"
                  value={formData.stdAdharNo}
                  onChange={handleChange} disabled={isSubmitted} maxLength={14}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Gender" : "लिंग"} <span style={{ color: 'red' }}>*</span></label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange} disabled={isSubmitted}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                >
                  <option value="">{schoolLanguage === 'English' ? "Select Gender" : "लिंग निवडा"}</option>
                  <option value="male">{schoolLanguage === 'English' ? "Male" : "मुलगा"}</option>
                  <option value="female">{schoolLanguage === 'English' ? "Female" : "मुलगी"}</option>

                </select>
              </div>

              <div >
                <div >
                  <label
                    style={{
                      display: 'block',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      color: '#4b5563',
                      marginBottom: '0.5rem'
                    }}
                  >
                    {schoolLanguage === 'English' ? '  Date Of Birth' : 'जन्मतारीख'}
                  </label>
                  <input
                    autoComplete="off"
                    type="date"
                    name='dob'
                    value={formData.dob}
                    ref={(el) => (inputs.current[27] = el)}
                    onChange={handleDOBChange} onKeyPress={handleChange}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      background: '#f9fafb',
                      transition: 'all 0.3s'
                    }} max={new Date().toISOString().split('T')[0]}
                  />
                </div>
              </div>
              <div >
                <div >
                  <label
                    style={{
                      display: 'block',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      color: '#4b5563',
                      marginBottom: '0.5rem'
                    }}
                  >
                    {schoolLanguage === 'English' ? 'Date Of Birth in words' : 'अक्षरी जन्मतारीख'}
                  </label>
                  <input
                    type="text"
                    value={formData.dobInWords} onKeyPress={handleChange}
                    readOnly
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      background: '#f9fafb',
                      transition: 'all 0.3s'
                    }}
                  />
                </div>
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Birth Place" : "जन्मस्थान"}</label>
                <input
                  type="text"
                  name="birthPlace"
                  value={formData.birthPlace}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Blood Group" : "रक्त गट"}</label>
                <select
                  name="bloodGroup"
                  value={formData.bloodGroup}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                >
                  <option value="">{schoolLanguage === 'English' ? "Select Blood Group" : "रक्त गट निवडा"}</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Birthmark" : "जन्मखूण"}</label>
                <input
                  type="text"
                  name="birthmark"
                  value={formData.birthmark}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
            </div>
          </div>

          {/* Demographic Information Section */}
          <div style={{ marginBottom: '2.5rem' }}>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.5rem'
            }}>
              {/* Religion */}


              <div >
                <div >
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#4b5563',
                    marginBottom: '0.5rem'
                  }}>
                    {schoolLanguage === 'English' ? ' Religion' : 'धर्म '}
                  </label>
                  <select
                    name="religion"
                    className="form-select"
                    onChange={handleReligionChange}
                    onFocus={() => handleFocus(22)}
                    ref={(el) => (inputs.current[22] = el)}
                    value={religion}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      background: '#f9fafb',
                      transition: 'all 0.3s'
                    }}
                  >
                    <option value="">{schoolLanguage === 'English' ? ' select religion' : 'धर्म निवडा'}</option>
                    <option value={schoolLanguage === 'English' ? 'Hindu' : 'हिंदू'}>
                      {schoolLanguage === 'English' ? 'Hindu' : 'हिंदू'}
                    </option>
                    <option value={schoolLanguage === 'English' ? 'Muslim' : ' मुस्लीम'}>
                      {schoolLanguage === 'English' ? 'Muslim' : ' मुस्लीम'}
                    </option>
                    <option value={schoolLanguage === 'English' ? 'Jain' : 'हिंदू'}>
                      {schoolLanguage === 'English' ? 'Jain' : 'जैन'}
                    </option>
                    <option value={schoolLanguage === 'English' ? 'Christians' : 'ख्रिश्चन'}>
                      {schoolLanguage === 'English' ? 'Christians' : 'ख्रिश्चन'}
                    </option>

                    {religions.filter(religion =>
                      religion !== 'Hindu' &&
                      religion !== 'हिंदू' &&
                      religion !== 'Muslim' &&
                      religion !== ' मुस्लीम' &&
                      religion !== 'Jain' &&
                      religion !== 'जैन' &&
                      religion !== 'Christians' &&
                      religion !== 'ख्रिश्चन '
                    ).map((religion, index) => (
                      <option key={index} value={religion}>
                        {religion}
                      </option>
                    ))}
                    <option value="addNewRel" style={{ backgroundColor: '#B9B9B9' }}>
                      {schoolLanguage === 'English' ? ' Add New Religion ' : 'नवीन धर्म जोडा'}
                    </option>
                  </select>
                </div>
              </div>



              {/* Caste */}
              <div >
                <div >
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#4b5563',
                    marginBottom: '0.5rem'
                  }}>
                    {schoolLanguage === 'English' ? ' Caste' : 'जात'}
                  </label>
                  <select
                    name="caste"
                    className="form-select"
                    onFocus={() => handleFocus(23)}
                    ref={(el) => (inputs.current[23] = el)}
                    onChange={handleCasteChange}
                    value={caste}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      background: '#f9fafb',
                      transition: 'all 0.3s'
                    }}
                  >
                    <option value="">{schoolLanguage === 'English' ? 'select Caste' : 'जात निवडा'}</option>

                    <option value={schoolLanguage === 'English' ? 'Maratha' : 'मराठा'}>
                      {schoolLanguage === 'English' ? 'Maratha' : 'मराठा'}
                    </option>
                    <option value={schoolLanguage === 'English' ? 'Brahmin' : 'ब्राह्मण'}>
                      {schoolLanguage === 'English' ? 'Brahmin' : 'ब्राह्मण'}
                    </option>
                    <option value={schoolLanguage === 'English' ? 'Dhangar' : 'धनगर'}>
                      {schoolLanguage === 'English' ? 'Dhangar' : 'धनगर'}
                    </option>

                    {castes.filter(nat => nat !== 'Maratha' && nat !== 'मराठा' && nat !== 'Brahmin' && nat !== 'ब्राह्मण' && nat !== 'धनगर' && nat !== 'Dhangar').map((nat, index) => (
                      <option key={index} value={nat}>
                        {nat}
                      </option>
                    ))}
                    <option value="addNewCaste" style={{ backgroundColor: '#B9B9B9' }}>
                      {schoolLanguage === 'English' ? ' Add New Caste ' : 'नवीन जात जोडा'}
                    </option>
                  </select>




                </div>
              </div>

              {/* Sub-Caste */}
              <div >
                <div >
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#4b5563',
                    marginBottom: '0.5rem'
                  }}> {schoolLanguage === 'English' ? ' sub-caste' : 'पोटजात'}</label>
                  <input
                    autoComplete="off"
                    type="text"
                    name="subCaste"
                    maxLength='30'
                    onChange={handleTextChange}
                    onKeyPress={handleEnterKey}
                    onFocus={() => handleFocus(24)}
                    ref={(el) => (inputs.current[24] = el)}
                    value={formData.subCaste}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      background: '#f9fafb',
                      transition: 'all 0.3s'
                    }}
                  />
                </div>
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Category" : "कॅटेगरी"}</label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                >
                  <option value="">{schoolLanguage === 'English' ? "Select Category" : "कॅटेगरी निवडा"}</option>
                  <option value="General">GEN</option>
                  <option value="SC">SC</option>
                  <option value="ST">ST</option>
                  <option value="OBC">OBC</option>
                  <option value="EWS">EWS</option>
                  <option value="NT">NT</option>
                  <option value="NTC">NTC</option>
                  <option value="NTD">NTD</option>
                  <option value="NTB ">NTB </option>
                  <option value="SEBC ">SEBC </option>
                  <option value="VJNT">VJNT</option>
                  <option value="DNT">DNT</option>
                  <option value="BC">BC</option>
                  <option value="MBC">MBC</option>
                  <option value="PWD">PWD </option>
                  <option value="FC">FC</option>
                </select>
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Nationality" : "राष्ट्रीयत्व"}</label>
                <input
                  type="text"
                  name="nationality"
                  value={formData.nationality}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />

              </div>
              <div >
                <div >
                  <label
                    style={{
                      display: 'block',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      color: '#4b5563',
                      marginBottom: '0.5rem'
                    }}
                  >
                    {schoolLanguage === 'English' ? ' Mother Tounge' : 'मातृभाषा '}
                  </label>
                  <select
                    name="MotherTounge"

                    onChange={handleMotherToungeChange} onFocus={() => handleFocus(21)}
                    ref={(el) => (inputs.current[21] = el)}
                    value={motherTounge}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      background: '#f9fafb',
                      transition: 'all 0.3s'
                    }}
                  >
                    <option value="">{schoolLanguage === 'English' ? 'select Mother Tounge' : 'मातृभाषा निवडा'}</option>

                    <option value="Marathi">{schoolLanguage === 'English' ? "Marathi" : "मराठी"}</option>
                    <option value="Hindi">{schoolLanguage === 'English' ? "Hindi" : "हिंदी"}</option>
                    <option value="English">{schoolLanguage === 'English' ? "English" : "इंग्रजी"}</option>
                    <option value="Urdu">{schoolLanguage === 'English' ? "Urdu" : "उर्दू"}</option>
                    <option value="Gujarati">{schoolLanguage === 'English' ? "Gujarati" : "गुजराती"}</option>
                    <option value="Kannada">{schoolLanguage === 'English' ? "Kannada" : "कन्नड"}</option>
                    <option value="Telugu">{schoolLanguage === 'English' ? "Telugu" : "तेलगू"}</option>
                    <option value="Tamil">{schoolLanguage === 'English' ? "Tamil" : "तमिळ"}</option>
                    <option value="Bengali">{schoolLanguage === 'English' ? "Bengali" : "बंगाली"}</option>
                    <option value="Punjabi">{schoolLanguage === 'English' ? "Punjabi" : "पंजाबी"}</option>
                    <option value="Other">{schoolLanguage === 'English' ? "Other" : "इतर"}</option>

                    {motherTounges.filter(nat => nat !== 'Marathi' && nat !== 'मराठी').map((nat, index) => (
                      <option key={index} value={nat}>
                        {nat}
                      </option>
                    ))}
                    <option value="addNewMotherTounge" style={{ backgroundColor: '#B9B9B9' }}>
                      {schoolLanguage === 'English' ? ' Add New Mother Tounge ' : 'नवीन मातृभाषा जोडा'}
                    </option>
                  </select>
                </div>
              </div>















              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '1.5rem'
              }}>
                <input
                  type="checkbox"
                  name="isMinority"
                  checked={formData.isMinority}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '1rem',
                    height: '1rem',
                    marginRight: '0.5rem'
                  }}
                />
                <label style={{
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563'
                }}>
                  {schoolLanguage === 'English' ? "Is Minority" : "अल्पसंख्याक"}
                </label>
              </div>
            </div>
          </div>

          {/* Location Information Section */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '1.5rem',
              paddingBottom: '0.5rem',
              borderBottom: '2px solid #e5e7eb'
            }}>{schoolLanguage === 'English' ? "Location Information" : "पत्ता माहिती"}</h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.5rem'
            }}>
              <div>

                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Country" : "देश"}</label>

                <select name="country" className="form-select" onChange={handleCountryChange} value={formData.country}>
                  <option value="">{schoolLanguage === 'English' ? 'select Country' : 'देश निवडा'}</option>
                  <option value={schoolLanguage === 'English' ? 'India' : 'भारत'}>
                    {schoolLanguage === 'English' ? 'India' : 'भारत'}
                  </option>

                </select>
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "State" : "राज्य"}</label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}
                >

                  {schoolLanguage === 'English' ? ' District' : 'जिल्हा'}</label>
                <select id="districtSelect" value={formData.district} onChange={handleDistrictChange}>
                  <option value="">  {schoolLanguage === 'English' ? ' Select District' : 'जिल्हा निवडा'}</option>
                  {districtsData.Maharashtra.map((district, index) => (
                    <option key={index} value={district}>{district}</option>
                  ))}
                </select>
              </div>


              <div className="form-outline flex-fill mb-0">
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Taluka" : "तालुका"}</label>

                <select id="talukaSelect" value={formData.taluka} onChange={handleTalukaChange}>
                  <option value="">  {schoolLanguage === 'English' ? ' Select Taluka' : 'तालुका निवडा'}</option>
                  {talukaOptions}
                </select>
              </div>

              <div style={{
                gridColumn: '1 / -1'
              }}>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Full Address" : "पत्ता"}</label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s',
                    minHeight: '100px'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Pincode" : "पिनकोड"}</label>
                <input
                  type="text"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
            </div>
          </div>

          {/* Contact Information Section */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '1.5rem',
              paddingBottom: '0.5rem',
              borderBottom: '2px solid #e5e7eb'
            }}>{schoolLanguage === 'English' ? "Contact Information" : "संपर्क माहिती"}</h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.5rem'
            }}>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Student Mobile No." : "विद्यार्थ्याचा फोन नंबर"} <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="mobileNo"
                  value={formData.mobileNo}
                  onChange={handleChange} disabled={isSubmitted} maxLength={10}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                  required
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Father's Mobile No." : "वडिलांचा फोन नंबर"}</label>
                <input
                  type="text"
                  name="fMobile"
                  value={formData.fMobile}
                  onChange={handleChange} disabled={isSubmitted} maxLength={10}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Mother's Mobile No." : "आईचा फोन नंबर"}</label>
                <input
                  type="text"
                  name="mMobile"
                  value={formData.mMobile} maxLength={10}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Aadhar Linked Mobile No." : "आधार लिंक केलेला मोबाईल क्र"}</label>
                <input
                  type="text"
                  name="adharmobileNo"
                  value={formData.adharmobileNo}
                  onChange={handleChange} disabled={isSubmitted} maxLength={10}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Student Email ID" : "ईमेल आयडी"}</label>
                <input
                  type="email"
                  name="stdemailId"
                  value={formData.stdemailId}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
            </div>
          </div>

          {/* Parents' Occupation Section */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '1.5rem',
              paddingBottom: '0.5rem',
              borderBottom: '2px solid #e5e7eb'
            }}>{schoolLanguage === 'English' ? "Parent's Occupation" : "पालकांची माहिती"}</h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.5rem'
            }}>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Father's Occupation" : "वडिलांचा व्यवसाय"}</label>
                <input
                  type="text"
                  name="fOccupation"
                  value={formData.fOccupation}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Mother's Occupation" : "आईचा व्यवसाय"}</label>
                <input
                  type="text"
                  name="mOccupation"
                  value={formData.mOccupation}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>
            </div>
          </div>



          {/* Bank Information Section */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '1.5rem',
              paddingBottom: '0.5rem',
              borderBottom: '2px solid #e5e7eb'
            }}>{schoolLanguage === 'English' ? "Bank Information" : "बँकेची माहिती"}</h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.5rem'
            }}>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Account Holder Name" : "खातेधारकाचे नाव"}</label>
                <input
                  type="text"
                  name="accHolderName"
                  value={formData.accHolderName}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Account Number" : "खाते क्र"}</label>
                <input
                  type="text"
                  name="accNo"
                  value={formData.accNo}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }} />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Bank Name" : "बँकेचे नाव"}</label>
                <input
                  type="text"
                  name="bankName"
                  value={formData.bankName}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }} />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Branch Name" : "शाखेचे नाव"}</label>
                <input
                  type="text"
                  name="branchName"
                  value={formData.branchName}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }} />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "IFSC Code" : "IFSC Code"}</label>
                <input
                  type="text"
                  name="IFSC"
                  value={formData.IFSC}
                  onChange={handleChange} disabled={isSubmitted}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }} />
              </div>

            </div>
          </div>

          {/* Photo Upload Section */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '1.5rem',
              paddingBottom: '0.5rem',
              borderBottom: '2px solid #e5e7eb'
            }}>{schoolLanguage === 'English' ? "Student Photo" : "विद्यार्थ्याचा फोटो"}</h2>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1.5rem'
            }}>
              <div style={{ flex: '1' }}>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#4b5563',
                  marginBottom: '0.5rem'
                }}>{schoolLanguage === 'English' ? "Upload Photo" : "फोटो अपलोड करा"}</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={uploadImage}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px dashed #d1d5db',
                    borderRadius: '8px',
                    background: '#f9fafb',
                    transition: 'all 0.3s'
                  }}
                />

              </div>
              <div style={{
                flex: '1',
                display: 'flex',
                justifyContent: 'center'
              }}>
                {formData.stdPhoto ? (
                  <div style={{
                    width: '150px',
                    height: '180px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '8px',
                    overflow: 'hidden'
                  }}>
                    <img
                      src={formData.stdPhoto}
                      alt="Student Preview"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>
                ) : (
                  <div style={{
                    width: '150px',
                    height: '180px',
                    border: '2px dashed #d1d5db',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#f9fafb'
                  }}>
                    <span style={{
                      fontSize: '0.875rem',
                      color: '#6b7280'
                    }}>{schoolLanguage === 'English' ? "No photo" : "फोटो नाही"}</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Submit Button */}
          {!isSubmitted && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '3rem'
            }}>
              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  padding: '1rem 2.5rem',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  fontWeight: '600',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  opacity: isSubmitting ? '0.7' : '1'
                }}
              >
                {isSubmitting ? "Submitting..." : "Submit Admission Form"}
              </button>
            </div>
          )}

        </form>

        {showPrintButton && (
          <div style={{ textAlign: 'center', marginTop: '-15px', marginBottom: '30px' }}>
            <button
              onClick={printForm}
              style={{
                padding: '1rem 2.5rem',
                background: 'linear-gradient(135deg, #34d399 0%, #059669 100%)',
                color: 'white',
                fontWeight: '600',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
              }}
            >
              Print Form

            </button>
          </div>
        )}


        {showPrintButton && (
          <div style={{ textAlign: 'center', marginTop: '-15px', marginBottom: '30px' }}>
            <button
              onClick={downloadPDF} // Change to downloadPDF
              style={{
                padding: '1rem 2.5rem',
                background: 'linear-gradient(135deg, #34d399 0%, #059669 100%)',
                color: 'white',
                fontWeight: '600',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
              }}
            >
              Download Form as PDF
            </button>
          </div>
        )}


        <style jsx>
          {
            `
/* Add this CSS to your existing styles */
@media (max-width: 768px) {
  body {
    font-size: 14px; /* Decrease base font size */
  }
.adm-head{
    padding:10px !important;
}
  .header-sch h1 {
    font-size: 18px !important; /* Smaller header font size */
  }

  .header-sch h2 {
    font-size: 16px; /* Smaller sub-header font size */
  }

  .header-sch p {
    font-size: 14px !important; /* Smaller sub-header font size */
  }
  .schlogo{
  width:50px !important;
  height:50px !important;
  }
}

    `
          }
        </style>
        {showNewReligionForm && (
          <div className="overlay">
            <div className="center-form">
              <div className="new-book-form">
                <label htmlFor="newReligionInput">
                  {schoolLanguage === 'English' ? 'Enter New Religion:' : 'नवीन धर्म प्रविष्ट करा:'}
                </label>
                <input
                  className="newRegInput"
                  type="text"
                  id="newReligionInput"
                  value={newReligion}
                  onChange={(e) => setNewReligion(e.target.value)}
                />
                <button className="registerNewSaveBtn" onClick={handleNewReligionSubmit}>
                  {schoolLanguage === 'English' ? (isEditingReligion ? 'Update' : 'Submit') : (isEditingReligion ? 'अपडेट करा' : 'प्रविष्ट करा')}
                </button>
                <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                {religions.length > 0 && (
                  <div className="book-list table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th className="text-center">{schoolLanguage === 'English' ? 'Religion' : 'धर्म'}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {religions.map((religion, index) => (
                          <tr key={index} onClick={() => handleRowClickReligion(index)}>
                            <td>{religion}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}



        {showNewMotherToungeForm && (
          <div className="overlay">
            <div className="center-form">
              <div className="new-book-form">
                <label htmlFor="newMotherToungeInput">
                  {schoolLanguage === 'English' ? 'Enter New Mother Tounge:' : 'नवीन मातृभाषा प्रविष्ट करा:'}
                </label>
                <input className="newRegInput" type="text" id="newMotherToungeInput" value={newMotherTounge} onChange={(e) => setNewMotherTounge(e.target.value)} />
                <button className="registerNewSaveBtn" onClick={handleNewMotherToungeSubmit}>
                  {schoolLanguage === 'English' ? (isEditingMotherTounge ? 'Update' : 'Submit') : (isEditingMotherTounge ? 'अपडेट करा' : 'प्रविष्ट करा')}
                </button>
                <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                {motherTounges.length > 0 && (
                  <div className="book-list table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th className="text-center">{schoolLanguage === 'English' ? 'Mother Tounge' : 'मातृभाषा'}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {motherTounges.map((MotherTounge, index) => (
                          <tr key={index} onClick={() => handleRowClickMotherTounge(index)}>
                            <td>{MotherTounge}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {showNewCasteForm && (
          <div className="overlay">
            <div className="center-form">
              <div className="new-book-form">
                <label htmlFor="newCasteInput">
                  {schoolLanguage === 'English' ? 'Enter New Caste:' : 'नवीन जात प्रविष्ट करा:'}
                </label>
                <input className="newRegInput" type="text" id="newCasteInput" value={newCaste} onChange={(e) => setNewCaste(e.target.value)} />
                <button className="registerNewSaveBtn" onClick={handleNewCasteSubmit}>
                  {schoolLanguage === 'English' ? (isEditingCaste ? 'Update' : 'Submit') : (isEditingCaste ? 'अपडेट करा' : 'प्रविष्ट करा')}
                </button>
                <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                {castes.length > 0 && (
                  <div className="book-list table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th className="text-center">{schoolLanguage === 'English' ? 'Caste' : 'जात'}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {castes.map((Caste, index) => (
                          <tr key={index} onClick={() => handleRowClickCaste(index)}>
                            <td>{Caste}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default SchoolAdmissionForm;